module.exports = __webpack_public_path__ + "img/visa-oi-matching-guidance.62e05e42.png";